var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60063 2.18213H16.3991C19.3873 2.18213 21.8183 4.61313 21.8182 7.60106V16.3996C21.8182 19.3875 19.3873 21.8185 16.3991 21.8185H7.60063C4.6127 21.8185 2.18182 19.3876 2.18182 16.3996V7.60106C2.18182 4.61313 4.6127 2.18213 7.60063 2.18213ZM16.3993 20.0763C18.4266 20.0763 20.0761 18.4269 20.0761 16.3996H20.076V7.60106C20.076 5.57379 18.4265 3.92436 16.3991 3.92436H7.60063C5.57337 3.92436 3.92406 5.57379 3.92406 7.60106V16.3996C3.92406 18.4269 5.57337 20.0764 7.60063 20.0763H16.3993ZM6.85715 12.0004C6.85715 9.16455 9.16419 6.85745 12 6.85745C14.8358 6.85745 17.1429 9.16455 17.1429 12.0004C17.1429 14.8362 14.8358 17.1432 12 17.1432C9.16419 17.1432 6.85715 14.8362 6.85715 12.0004ZM8.62799 12.0003C8.62799 13.8596 10.1407 15.3722 12 15.3722C13.8593 15.3722 15.372 13.8596 15.372 12.0003C15.372 10.1409 13.8594 8.62821 12 8.62821C10.1406 8.62821 8.62799 10.1409 8.62799 12.0003Z",
    fill: "#F1DFDA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_6312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60063 2.18213H16.3991C19.3873 2.18213 21.8183 4.61313 21.8182 7.60106V16.3996C21.8182 19.3875 19.3873 21.8185 16.3991 21.8185H7.60063C4.6127 21.8185 2.18182 19.3876 2.18182 16.3996V7.60106C2.18182 4.61313 4.6127 2.18213 7.60063 2.18213ZM16.3993 20.0763C18.4266 20.0763 20.0761 18.4269 20.0761 16.3996H20.076V7.60106C20.076 5.57379 18.4265 3.92436 16.3991 3.92436H7.60063C5.57337 3.92436 3.92406 5.57379 3.92406 7.60106V16.3996C3.92406 18.4269 5.57337 20.0764 7.60063 20.0763H16.3993ZM6.85715 12.0004C6.85715 9.16455 9.16419 6.85745 12 6.85745C14.8358 6.85745 17.1429 9.16455 17.1429 12.0004C17.1429 14.8362 14.8358 17.1432 12 17.1432C9.16419 17.1432 6.85715 14.8362 6.85715 12.0004ZM8.62799 12.0003C8.62799 13.8596 10.1407 15.3722 12 15.3722C13.8593 15.3722 15.372 13.8596 15.372 12.0003C15.372 10.1409 13.8594 8.62821 12 8.62821C10.1406 8.62821 8.62799 10.1409 8.62799 12.0003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_6312)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bd2517672b3af5e5dda3af2df2886241.svg";
export { ForwardRef as ReactComponent };